import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import './styles.css';


const EmptyStudies = ({ className }) => {
  const { t } = useTranslation('StudyList');

  return (
    <div className={classnames('flex flex-col items-center justify-center py-16', className)}>
      <div className="relative flex items-center justify-center mb-6">
        <div className="empty-studies-pulse-outer" />
        <div className="empty-studies-pulse-inner" />
        <div className="empty-studies-icon-container">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="url(#emptyGrad)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <defs>
              <linearGradient id="emptyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#60a5fa"/>
                <stop offset="100%" stopColor="#a78bfa"/>
              </linearGradient>
            </defs>
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        </div>
      </div>

      <h3 className="font-semibold text-lg mb-1 empty-studies-title">
        {t('No studies available')}
      </h3>
    </div>
  );
};

EmptyStudies.defaultProps = {
  className: '',
};

EmptyStudies.propTypes = {
  className: PropTypes.string,
};

export default EmptyStudies;
